import React from "react";
import { Dropdown, IconButton, Button } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { getCheckedBoxes } from "data/app/appSelectors";
import { useSelector } from "react-redux";

interface Props {
	id?: string;
	isActive: boolean;
	isDisabled?: boolean;
	loading?: boolean;
}

function InstancesMenu({ id, isActive, isDisabled = false, loading }: Props) {
	const { t } = useTranslation();

	const history = useHistory();

	const checkboxes = useSelector(getCheckedBoxes);

	let terminateLabel = t("main.activityInstances.labels.terminate");
	let deleteLabel = t("main.activityInstances.labels.delete");
	const isRowSelected = id && checkboxes.includes(id);
	if (isRowSelected || id === undefined) {
		const selectedCount = checkboxes.length;
		terminateLabel += ` (${selectedCount})`;
		deleteLabel += ` (${selectedCount})`;
	}

	const onTerminateClick = () => {
		let newUrl = `${window.location.pathname}?`;
		if (isRowSelected || id === undefined) {
			for (const uuid of checkboxes) {
				newUrl += `terminateId=${uuid}&`;
			}
		} else {
			newUrl += `terminateId=${id}`;
		}
		history.push(newUrl);
	};

	const onDeleteClick = () => {
		let newUrl = `${window.location.pathname}?`;
		if (isRowSelected || id === undefined) {
			for (const uuid of checkboxes) {
				newUrl += `deleteId=${uuid}&`;
			}
		} else {
			newUrl += `deleteId=${id}`;
		}
		history.push(newUrl);
	};

	return (
		<>
			<Dropdown
				id={`activityInstanceMenu__dropdown__${id}`}
				disabled={isDisabled || loading ? true : false}
				menuBtn={
					<IconButton
						className="btn-basic--dark"
						icon="ellipsis-v"
						label={t("main.labels.menu")}
					/>
				}
				align="right">
				{isActive && (
					<Button
						name="highPriority"
						label={terminateLabel}
						className="dropdown-item btn-basic--default"
						value="terminate"
						onClick={onTerminateClick}
					/>
				)}
				<Button
					name="lowPriority"
					label={deleteLabel}
					className="dropdown-item btn-basic--default"
					value="delete"
					onClick={onDeleteClick}
				/>
			</Dropdown>
		</>
	);
}

export default InstancesMenu;
